module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "programming-dashboard-unit-loader"
  }, [_c('content-loader', {
    attrs: {
      "height": 189,
      "width": 530,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "191.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "19.61",
      "rx": "0",
      "ry": "0",
      "width": "207.44",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "39.71",
      "rx": "0",
      "ry": "0",
      "width": "172.87",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "72.26",
      "rx": "0",
      "ry": "0",
      "width": "138.29",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "92.36",
      "rx": "0",
      "ry": "0",
      "width": "103.72",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "123.5",
      "rx": "0",
      "ry": "0",
      "width": "34.57",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "142.19",
      "rx": "0",
      "ry": "0",
      "width": "25.93",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "170.33",
      "rx": "0",
      "ry": "0",
      "width": "12.97",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "188.81",
      "rx": "0",
      "ry": "0",
      "width": "8.64",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "191.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "81.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68.63",
      "y": "19.61",
      "rx": "0",
      "ry": "0",
      "width": "207.44",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "102.55",
      "y": "39.71",
      "rx": "0",
      "ry": "0",
      "width": "172.87",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "137.25",
      "y": "72.26",
      "rx": "0",
      "ry": "0",
      "width": "138.29",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "171.94",
      "y": "92.36",
      "rx": "0",
      "ry": "0",
      "width": "103.72",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "241.32",
      "y": "142.52",
      "rx": "0",
      "ry": "0",
      "width": "34.57",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "249.8",
      "y": "122.5",
      "rx": "0",
      "ry": "0",
      "width": "25.93",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "263.68",
      "y": "168.97",
      "rx": "0",
      "ry": "0",
      "width": "12.97",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "261.42",
      "y": "188.13",
      "rx": "0",
      "ry": "0",
      "width": "14.95",
      "height": "16.97"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37429d67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/content-loaders/ProgrammingDashboardUnitLoader.vue
// module id = 3221
// module chunks = 3